import { render, staticRenderFns } from "./shouldhave.vue?vue&type=template&id=9453acaa&scoped=true&"
import script from "./shouldhave.vue?vue&type=script&lang=js&"
export * from "./shouldhave.vue?vue&type=script&lang=js&"
import style0 from "./shouldhave.vue?vue&type=style&index=0&id=9453acaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9453acaa",
  null
  
)

export default component.exports